module.exports = __webpack_public_path__ + "37cfebfb25a2832ceacc0ae94c949529.svg";


//////////////////
// WEBPACK FOOTER
// ./src/screens/App/screens/Home/images/paso3.svg
// module id = 1466
// module chunks = 0